import React from "react";
import Styled from './styled';
import Dao from '../../assets/DAO.svg';
import Roobee from '../../assets/roobee.svg';
import Menu from '../../assets/menu.svg';
import Close from '../../assets/close.svg';

type HeaderProps = {
  onClick: any;
  active: boolean;
}

const Header = ({onClick, active}: HeaderProps) => {
  return (
    <Styled.Wrapper>
      <Styled.Logos>
        <Styled.Roobee src={Roobee} />
        <Styled.Dao src={Dao} />
      </Styled.Logos>
      <Styled.Button onClick={onClick}>
        <Styled.Menu src={active ? Close : Menu} />
      </Styled.Button>
    </Styled.Wrapper>
  );
};

export default Header;
